export default __webpack_public_path__ + "static/media/cardIMG.3160da8e.png";